function cc_format(value: string) {
  if (!value) return "";
  const numericValue = value.replace(/[^0-9]/g, "");
  const limitedValue = numericValue.slice(0, 16);
  const matches = limitedValue.match(/\d{1,4}/g);

  return matches ? matches.join(" ") : "";
}

export default cc_format;
